/**
 * useRegistry.js
 * Manages the card-to-person registry stored in localStorage.
 * Persists across page refreshes — no backend needed.
 */

import { useState, useCallback } from "react";

const STORAGE_KEY = "rfid_registry";

function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

function save(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function useRegistry() {
  const [registry, setRegistry] = useState(load); // { "UID": { name, studentId, registeredAt } }

  const register = useCallback((uid, name, studentId) => {
    setRegistry((prev) => {
      const next = {
        ...prev,
        [uid]: {
          name:         name.trim(),
          studentId:    studentId.trim(),
          registeredAt: new Date().toLocaleString(),
        },
      };
      save(next);
      return next;
    });
  }, []);

  const unregister = useCallback((uid) => {
    setRegistry((prev) => {
      const next = { ...prev };
      delete next[uid];
      save(next);
      return next;
    });
  }, []);

  const lookup = useCallback(
    (uid) => registry[uid] || null,
    [registry]
  );

  return { registry, register, unregister, lookup };
}
